const rubNoCents = new Intl.NumberFormat('ru-RU', {
  style: 'currency',
  currency: 'RUB',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export function formatPrice(value: number | null | undefined) {
  if (value == null || Number.isNaN(value)) return '—';
  return rubNoCents.format(value);
}
